module.exports = __webpack_public_path__ + "static/media/Reserves-white.9389e445.svg";